var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.33 18.75c.231 0 .421-.19.421-.422v-.844c0-.232-.19-.422-.422-.422H7.376c-.931 0-1.687-.755-1.687-1.687v-6.75c0-.932.756-1.687 1.687-1.687h2.953c.232 0 .422-.19.422-.422v-.844c0-.232-.19-.422-.422-.422H7.376c-1.863 0-3.375 1.512-3.375 3.375v6.75c0 1.863 1.512 3.375 3.375 3.375h2.953zm5.769-.69l5.78-5.765c.164-.165.164-.432 0-.597l-5.78-5.766c-.166-.162-.433-.162-.598.004l-.69.689c-.168.168-.164.44.008.6l3.976 3.86h-8.747c-.232 0-.422.19-.422.423v.984c0 .232.19.422.422.422h8.747l-3.976 3.857c-.169.165-.172.436-.007.6l.689.69c.165.165.432.165.598 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconLogOut);
export default __webpack_public_path__ + "static/media/elements-icon-log-out.596d1438d75df37c6d4fa57ea5082e61.svg";
export { ForwardRef as ReactComponent };